import React from 'react'
import EmptyBox from '../MyRecords/EmptyBox'

export default ({ searchTerm }) => (
  <div className="empty-placeholder-wrapper">
    <EmptyBox />
    <h2>No results were found for "{searchTerm}"</h2>
    <p>Try your search again with different filters or a different search term.</p>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Search/EmptySearchPlaceholder.js